var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueBubblingTickIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#A4D7FA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 20.5412,
    cy: 19.4553,
    r: 8.18182,
    fill: "#3876BB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 8C13.3727 8 8 13.3727 8 20C8 26.6273 13.3727 32 20 32C26.6273 32 32 26.6273 32 20C32 13.3727 26.6273 8 20 8ZM25.2015 17.9709C25.2972 17.8614 25.3701 17.7339 25.4159 17.5958C25.4617 17.4577 25.4794 17.3119 25.4679 17.1669C25.4565 17.0219 25.4162 16.8806 25.3494 16.7514C25.2825 16.6222 25.1905 16.5077 25.0788 16.4146C24.967 16.3214 24.8378 16.2516 24.6987 16.2092C24.5595 16.1667 24.4133 16.1525 24.2686 16.1674C24.1239 16.1824 23.9836 16.2261 23.8561 16.296C23.7285 16.3659 23.6162 16.4606 23.5258 16.5745L18.8349 22.2025L16.4076 19.7742C16.2019 19.5755 15.9263 19.4655 15.6403 19.468C15.3543 19.4705 15.0806 19.5852 14.8784 19.7875C14.6761 19.9897 14.5614 20.2633 14.5589 20.5494C14.5564 20.8354 14.6664 21.111 14.8651 21.3167L18.1378 24.5895C18.245 24.6966 18.3733 24.7802 18.5146 24.835C18.6559 24.8898 18.8071 24.9145 18.9585 24.9076C19.1099 24.9007 19.2582 24.8624 19.3939 24.795C19.5297 24.7277 19.6499 24.6328 19.7469 24.5164L25.2015 17.9709Z",
    fill: "#A4D7FA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBubblingTickIcon);
export default __webpack_public_path__ + "static/media/BlueBubblingTickIcon.6400f8ebe54d277223d21bbf684d6bcf.svg";
export { ForwardRef as ReactComponent };